import { useState, useEffect, useCallback } from 'react';

/**
 * Detects horizontal overflow on datagrid for last-column shadow.
 * Sticky column styles are applied separately (not gated on showShadow).
 */
export const useLastColumnShadow = (scrollContainerRef, isLayoutReady = true) => {
    const [showShadow, setShowShadow] = useState(false);

    const checkScroll = useCallback(() => {
        const container = scrollContainerRef.current;
        if (!container) {
            return;
        }

        const table = container.querySelector('.RaDatagrid-table, .MuiTable-root');
        if (!table) {
            setShowShadow(false);
            return;
        }

        const hasHorizontalScroll = table.scrollWidth > container.clientWidth + 1;
        setShowShadow(hasHorizontalScroll);
    }, [scrollContainerRef]);

    useEffect(() => {
        if (!isLayoutReady) {
            return;
        }

        const scheduleCheck = () => {
            requestAnimationFrame(() => {
                requestAnimationFrame(checkScroll);
            });
        };

        const resizeObserver = new ResizeObserver(scheduleCheck);
        const container = scrollContainerRef.current;

        if (container) {
            resizeObserver.observe(container);
            const table = container.querySelector('.RaDatagrid-table, .MuiTable-root');
            if (table) {
                resizeObserver.observe(table);
            }
        }

        scheduleCheck();
        const timeoutId = globalThis.setTimeout(scheduleCheck, 100);
        const timeoutId2 = globalThis.setTimeout(scheduleCheck, 400);

        return () => {
            resizeObserver.disconnect();
            globalThis.clearTimeout(timeoutId);
            globalThis.clearTimeout(timeoutId2);
        };
    }, [scrollContainerRef, isLayoutReady, checkScroll]);

    return { showShadow };
};
